var checker_id = null;
const prices_txt = {
    card: {
        year: "15.90 US$ x 12 meses",
        six_months: "19.90 US$ x 6 meses",
        three_months: "29.90 US$ x 3 meses",
        month: "39.90 US$ x 1 mes",
    },
    qr: {
        year: "200 Bs. x 12 meses",
        six_months: "250 Bs. x 6 meses",
        three_months: "300 Bs. x 3 meses",
        month: "400 Bs. x 1 mes",
    }
};
const setPaymentSections = (value) => {
    setTexts()
    if (value === 'card') {
        $('#card-section').addClass('d-block');
        $('#card-section').removeClass('d-none');
        $('#qr-section').addClass('d-none');
        $('#qr-section').removeClass('d-block');
        unsetChecker();
    }
    if (value === 'qr') {
        get_qr();
        $('#card-section').addClass('d-none');
        $('#card-section').removeClass('d-block');
        $('#qr-section').addClass('d-block');
        $('#qr-section').removeClass('d-none');
        setChecker();
    }
}
const setRadios = () => {
    $('.time_suscription').on('change', (e) => {
        if (document.payform.type_payment.value === 'qr') {
            get_qr();
            setChecker();
        }
    });

    $('.check_type_payment').on('change', (e) => {
        if (e.target.checked) {
            setPaymentSections(e.target.value);
        }
    });
}
const setTexts = () => {
    let type_payment = document.payform.type_payment.value;

    if (type_payment == "card") {
        $('#year_label').html(prices_txt.card.year);
        $('#six_month_label').html(prices_txt.card.six_months);
        $('#three_month_label').html(prices_txt.card.three_months);
        $('#month_label').html(prices_txt.card.month);
    } else {
        $('#year_label').html(prices_txt.qr.year);
        $('#six_month_label').html(prices_txt.qr.six_months);
        $('#three_month_label').html(prices_txt.qr.three_months);
        $('#month_label').html(prices_txt.qr.month);
    }
}
const download_qr = () => {
    var base64Data = $('#qr-image').attr('src');
    if (base64Data) {
        var $link = $('<a>').attr('href', base64Data).attr('download', 'image.png');
        $('body').append($link);
        $link[0].click();
        $link.remove();
    }
}
const get_qr = async () => {
    $('#qr-image').css('opacity', '0.5');
    let time_suscription = document.payform.time_suscription.value;
    let user_id = document.payform.one_user_id.value;

    /* check localStorage */
    let qr_info = getQRInfo();
    if (!checkQRInfo(qr_info)) {
        $('#loading-qr').show();
        let res = await axios.post('/api/get-qr-payment', {
            time_suscription: time_suscription,
            user_id: user_id
        }, { withCredentials: true });

        if (res.data.success) {
            storeQRInfo({
                image: `data:image/png;base64,${res.data.data.qr}`,
                time_suscription: time_suscription,
                movimiento_id: res.data.data.movimiento_id
            });

            $('#qr-image').attr('src', `data:image/png;base64,${res.data.data.qr}`)
                .attr('movimiento_id', `${res.data.data.movimiento_id}`);
        }
        $('#loading-qr').hide();
    } else {
        $('#qr-image').attr('src', qr_info.image)
            .attr('movimiento_id', qr_info.movimiento_id);
    }

    $('#qr-image').css('opacity', '1');
}
const verifyPayment = async () => {
    $('#verify_btn').html("VERIFICANDO...").attr('disabled', true);

    let mov_id = $('#qr-image').attr('movimiento_id');
    let time_suscription = document.payform.time_suscription.value;

    if (mov_id) {
        let res = await axios.get(`/api/check-qr-payment/${mov_id}`, { withCredentials: true });
        let { data } = res.data;

        if (data.estado === "Pendiente") {
            console.log("Pago pendiente...");
        }

        if (data.estado === "Completado") {
            removeQRInfo();

            swal.fire({
                icon: "info",
                title: "Pago confirmado",
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#0BB783',
                html: `Depósito recibido de:<br/>
                            <p>
                                ${data.remitente?.nombre} (${data.remitente?.banco})<br/>
                                DocNo.: ${data.remitente?.documento}
                            </p>
                            <span>Haga click en aceptar para continuar</span>`
            }).then(res => {
                if(document.payform.one_user_id.value === "0") {
                    window.location.href = `https://myquickone.com/signin-qr/${mov_id}`;
                } else {
                    window.location.href = "https://one.quick.com.bo";
                }

            });

            // Clear QR Checker
            unsetChecker();
        }
    }

    $('#verify_btn').html("VERIFICAR PAGO").attr('disabled', false);
}
const storeQRInfo = (info) => {
    let now = dayjs();
    info = { ...info, date: now.format() };
    localStorage.setItem('qr_info', JSON.stringify(info));
}
const getQRInfo = () => {
    let qr_info = localStorage.getItem('qr_info');
    return JSON.parse(qr_info);
}
const checkQRInfo = (qr_info) => {
    let time_suscription = document.payform.time_suscription.value;
    let now = dayjs();
    if (!qr_info) { return false; }
    qr_info.date = (dayjs.isDayjs(qr_info.date)) ? qr_info.date : dayjs(qr_info.date);
    let date_ok = now.isAfter(qr_info.date);
    let tsuscr = time_suscription === qr_info.time_suscription;
    return date_ok && tsuscr;
}
const removeQRInfo = () => {
    localStorage.removeItem('qr_info');
}
const unsetChecker = () => {
    if (checker_id) { clearInterval(checker_id); checker_id = null; }
}
const setChecker = () => {
    if (checker_id) { unsetChecker(); }
    checker_id = setInterval(() => { verifyPayment(); }, 10000);
}

$( document ).ready(function() {
    setRadios();
    setPaymentSections(document.payform.type_payment.value);
    $('#btn-download-qr').on('click', () => download_qr());
    $('#verify_btn').on('click', () => verifyPayment());
});
